import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./Swiper.css";
import { postData, serverURL } from "../services/NodeServices";
// Ensure postData function is correctly imported

export default function SliderSection() {
  const [images, setImages] = useState([]);

  const isMobile = window.innerWidth <= 768;

  const getCurrentImages = async () => {
    try {
      const result = await postData("api/products/getbanners");
      if (result.status) {
        updateImages(result.banners);
      }
    } catch (error) {
      console.error("Error fetching banners:", error);
    }
  };

  const updateImages = (banners) => {
    const width = window.innerWidth;
    let selectedImages = [];

    if (width <= 480) {
      selectedImages = banners.set3.split(",");
    } else if (width <= 850) {
      selectedImages = banners.set2.split(",");
    } else {
      selectedImages = banners.set1.split(",");
    }

    setImages(selectedImages);
  };

  useEffect(() => {
    getCurrentImages();
    window.addEventListener("resize", () => getCurrentImages());

    return () => {
      window.removeEventListener("resize", () => getCurrentImages());
    };
  }, []);

  return (
    <section className=" md:pt-24 pt-16 ">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={20}
        slidesPerView={1}
        navigation
      
       pagination={{ clickable: true, dynamicBullets: true }}
        // dots
  autoplay={{
    delay: 5000, // 3s delay
    disableOnInteraction: false, // keeps autoplay after interaction
  }}
        loop={true}
        
      >
     {/*    {images.map((image, index) => (
          <SwiperSlide key={index}>
          <a href="/clanfest">
          <img src={`${serverURL}images/${image}`} alt={`Slide ${index + 1}`} width={2048} height={"100vh"} />
          </a>
          </SwiperSlide>
        ))} */}
         

          {isMobile? <>
          
        {/*    <SwiperSlide >
          <a href="https://www.blazestore.in/category/men/All">
          <img   src={`image/mobile view banner.png`} alt={`banner`} className="mt-8 max-sm:h-auto !important"  width={2048}  />
          </a>
          </SwiperSlide> */}
            <SwiperSlide >
          <a href="https://www.blazestore.in/category/men/All">
          <img   src={`image/ban4.png`} alt={`banner`} className="mt-8 max-sm:h-auto !important"  width={2048}  />
          </a>
          </SwiperSlide>
            <SwiperSlide >
          <a href="https://www.blazestore.in/category/men/All">
          <img src={`image/ban5.png`} alt={`banner`} className="mt-8 max-sm:h-auto !important" width={2048}  />
          </a>
          </SwiperSlide>
          </>:<>

          {/*  <SwiperSlide >
          <a href="https://www.blazestore.in/category/men/All">
          <img src={`image/T-Shirt (7).png`} alt={`banner`} className="mt-8 max-sm:h-auto !important" width={2048}  />
          </a>
          </SwiperSlide> */}
        
            <SwiperSlide >
          <a href="https://www.blazestore.in/category/men/All">
          <img src={`image/ban2.png`} alt={`banner`} className="mt-8 max-sm:h-auto !important" width={2048}  />
          </a>
          </SwiperSlide>
            <SwiperSlide >
          <a href="/clanfest">
          <img src={`image/ban3.png`} alt={`banner`} className="mt-8 max-sm:h-auto !important" width={2048}  />
          </a>
          </SwiperSlide>
          
          </>}

      </Swiper>

      
    {/*   <video
       style={{width:'100vw',height:'100vh',objectFit:'cover',zIndex:222222,objectFit:'cover'}}
        autoPlay
        loop
        muted
        
        controls={false}
        playsInline
        className="slider-video">
        <source src={`/videomain.mp4`} type="video/mp4" />
        </video> */}
    </section>
  );
}
